// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2tfuY","label":"Radio_label__11Nap","checkMark":"Radio_checkMark__2Ynq2","disabled":"Radio_disabled__1Hcu6"};